import React, { useEffect, useRef, useState } from "react";

import {
  getDynamicValue,
  useRevalidateAndCalculations,
  validate,
} from "@/components/add-v2/validate";
import { dispatchCtxChange } from "@/components/add-v2/ui";
import css from "./.module.scss";
import { handleOnPasteCaptureNumbers } from "@/lib/numbersOnPase";

const NumberFormat = new Intl.NumberFormat("en-SA", {
  maximumFractionDigits: 2,
});

function format(value) {
  if (value === null) return "";
  if (value === undefined) return "";
  if (value === "") return "";
  if ((value + "").endsWith("."))
    return NumberFormat.format(value.slice(0, value.length - 1)) + ".";

  return NumberFormat.format(value);
}

export function TextFieldComponent({
  rules,
  label,
  dependencies,
  name,
  hide,
  ctxRef,
  nested,
  type,
  note,
  value: initialValue,
  dynamicProps: dp,
  calculations,
  ...props
} = {}) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);
  const rootRef = useRef(null);
  const dynamicProps = useRevalidateAndCalculations({
    rules,
    name,
    label: label?.ar,
    calculations,
    value,
    setError,
    setValue,
    dependencies,
    ctxRef,
    dynamicProps: dp,
  });

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.addEventListener("validate", (e) => {
      setError(e?.detail?.error);
    });
  }, []);

  if (hide && note)
    return (
      <div ref={rootRef}>
        <p>{label?.ar || name}</p>
        <div
          className={
            css.textField +
            (props.readOnly ? " " + css.readOnly : "") +
            (error ? " " + css.hasError : "")
          }
        >
          <input
            {...props}
            {...dynamicProps}
            hidden
            value={type === "number" ? format(value || "") : value || ""}
            name={name}
            onPasteCapture={
              type === "number" ? handleOnPasteCaptureNumbers : null
            }
            inputMode={type === "number" ? "numeric" : undefined}
            onKeyDown={(e) => {
              // prevent any char unless its number
              if (e.ctrlKey || e.key === "Tab" || e.key === "Backspace") return;

              const nextValue = (e.target.value + e.key).replaceAll(",", "");
              if (Number.isNaN(+nextValue)) return e.preventDefault();
            }}
            onChange={(e) => {
              const currentValue =
                type === "number"
                  ? e.target.value?.replaceAll(",", "")
                  : e.target.value;

              setValue(currentValue);
              setError(
                validate({
                  rules,
                  label: label?.ar,
                  currentValue,
                  ctx: ctxRef.current,
                }),
              );
              dispatchCtxChange(e.target, {
                value: type === "number" ? +currentValue : currentValue,
                name,
                nested,
              });
            }}
          />
          <p>{note?.ar}</p>
        </div>
      </div>
    );
  if (hide)
    return (
      <input
        {...props}
        {...dynamicProps}
        hidden
        value={type === "number" ? format(value || "") : value || ""}
        name={name}
        onPasteCapture={type === "number" ? handleOnPasteCaptureNumbers : null}
        inputMode={type === "number" ? "numeric" : undefined}
        onKeyDown={(e) => {
          // prevent any char unless its number
          if (e.ctrlKey || e.key === "Tab" || e.key === "Backspace") return;

          const nextValue = (e.target.value + e.key).replaceAll(",", "");
          if (Number.isNaN(+nextValue)) return e.preventDefault();
        }}
        onChange={(e) => {
          const currentValue =
            type === "number"
              ? e.target.value?.replaceAll(",", "")
              : e.target.value;

          setValue(currentValue);
          setError(
            validate({
              rules,
              label: label?.ar,
              currentValue,
              ctx: ctxRef.current,
            }),
          );
          dispatchCtxChange(e.target, {
            value: type === "number" ? +currentValue : currentValue,
            name,
            nested,
          });
        }}
      />
    );
  return (
    <div ref={rootRef}>
      <p>{label?.ar || name}</p>
      <div
        className={
          css.textField +
          (props.readOnly ? " " + css.readOnly : "") +
          (error ? " " + css.hasError : "")
        }
      >
        <input
          {...props}
          {...dynamicProps}
          value={type === "number" ? format(value || "") : value || ""}
          name={name}
          onPasteCapture={
            type === "number" ? handleOnPasteCaptureNumbers : null
          }
          inputMode={type === "number" ? "numeric" : undefined}
          onKeyDown={(e) => {
            // prevent any char unless its number
            if (e.ctrlKey || e.key === "Tab" || e.key === "Backspace") return;

            const nextValue = (e.target.value + e.key).replaceAll(",", "");
            if (Number.isNaN(+nextValue)) return e.preventDefault();
          }}
          onChange={(e) => {
            const currentValue =
              type === "number"
                ? e.target.value?.replaceAll(",", "")
                : e.target.value;

            setValue(currentValue);
            setError(
              validate({
                rules,
                label: label?.ar,
                currentValue,
                ctx: ctxRef.current,
              }),
            );
            dispatchCtxChange(e.target, {
              value: type === "number" ? +currentValue : currentValue,
              name,
              nested,
            });
          }}
        />
      </div>

      <p className={css.error}> {error}</p>
    </div>
  );
}
